import {z} from 'zod';

export const TITLE_EXTENSION_LANGUAGES = [
  'cs',
  'en',
  'de',
  'es',
  'fr',
  'nl',
  'it',
  'pl',
  'sk',
] as const;

export const TitleExtensionLanguageSchema = z.enum(TITLE_EXTENSION_LANGUAGES);
export type TitleExtensionLanguage = z.infer<typeof TitleExtensionLanguageSchema>;

export const TitleExtensionShortNameSchema = z.object({
  language: TitleExtensionLanguageSchema,
  shortName: z.string().min(1).max(255),
});
export type TitleExtensionShortName = z.infer<typeof TitleExtensionShortNameSchema>;

export const TitleExtensionEquipmentRequestItemSchema = z.object({
  featureKey: z.string().min(1),
  shortNames: z.array(TitleExtensionShortNameSchema),
});
export type TitleExtensionEquipmentRequestItem = z.infer<
  typeof TitleExtensionEquipmentRequestItemSchema
>;

export const TitleExtensionEquipmentRequestBodySchema = z.object({
  separator: z.string().min(1).max(10),
  items: z.array(TitleExtensionEquipmentRequestItemSchema),
});
export type TitleExtensionEquipmentRequestBody = z.infer<
  typeof TitleExtensionEquipmentRequestBodySchema
>;

export const TitleExtensionEquipmentResponseItemSchema =
  TitleExtensionEquipmentRequestItemSchema.extend({
    name: z.string(),
  });
export type TitleExtensionEquipmentResponseItem = z.infer<
  typeof TitleExtensionEquipmentResponseItemSchema
>;

export const TitleExtensionEquipmentResponseSchema = z.object({
  country: z.string().length(3),
  languages: z.array(TitleExtensionLanguageSchema),
  separator: z.string(),
  isDefault: z.boolean(),
  items: z.array(TitleExtensionEquipmentResponseItemSchema),
});
export type TitleExtensionEquipmentResponse = z.infer<typeof TitleExtensionEquipmentResponseSchema>;

export type SaveTitleExtensionEquipmentApiArg = {
  titleExtensionEquipmentRequestBody: TitleExtensionEquipmentRequestBody;
};

export const AddableTitleExtensionFeatureSchema = z.object({
  featureKey: z.string(),
  name: z.string(),
});
export type AddableTitleExtensionFeature = z.infer<typeof AddableTitleExtensionFeatureSchema>;

export const AddableTitleExtensionFeaturesResponseSchema = z.object({
  items: z.array(AddableTitleExtensionFeatureSchema),
});
export type AddableTitleExtensionFeaturesResponse = z.infer<
  typeof AddableTitleExtensionFeaturesResponseSchema
>;
